import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { dropdownsRequest, dropdownsSuccess, dropdownsFailure } from '../reducers/dropdowns';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getRegDropdowns`;

function* dropdownsAxios() {
  const state = yield select(fullState => fullState);
  var userId
  if(!state.loginReducer.user){
    userId=0;
  }else{
    userId= state.loginReducer.user.userId
  }
  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?user_id=`+userId,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },

    }),
  );

  return response;
}

function* workerDropdownsSaga() {
  try {
    const response = yield call(dropdownsAxios);
    const responseFromDropdowns = response.data;

    yield put(dropdownsSuccess(responseFromDropdowns));
    if (response.status === 500) {
      yield put(dropdownsFailure(responseFromDropdowns));
    }
  } catch (error) {
    
    yield put(dropdownsFailure(error));
  }
}

export function* watcherDropdownsSaga() {
  yield takeLatest(dropdownsRequest().type, workerDropdownsSaga);
}
